// Module
var code = "<svg id=\"{{$ctrl.overlayid}}\" class=\"alarm-video-overlay\" ng-attr-view_box=\"0 0 {{$ctrl.w}} {{$ctrl.h}}\" overflow=\"hidden\" xmlns=\"http://www.w3.org/2000/svg\"></svg> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/AlarmVideo/AlarmVideoOverlay.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;